import React, { useState } from 'react';
import { FaLock, FaEye, FaEyeSlash } from 'react-icons/fa';
import "../../styles/Auth/resetPasswordPopup.css";
import { postData } from '../../webService/webservice.js';
import { toast } from 'react-toastify';

const PasswordResetPopup = ({ token, onClose }) => {
    console.log("Reset Token:", token);
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const [touched, setTouched] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const handleReset = async () => {
        if (!newPassword || !confirmPassword) {
            setError('Both fields are required.');
            return;
        } else if (newPassword !== confirmPassword) {
            setError('Passwords do not match.');
            return;
        }

        // Simulate backend call
        try {
            setError('');
            setIsLoading(true);
            const route = `users/user/resetpassword/${token}`;
            const data = { newPassword };

            const result = await postData(route, data);
            setIsLoading(false);
            setSuccess(true);
            toast.success(result.message || 'Password reset successfully');
        } catch (error) {
            setIsLoading(false);
            setError(error.message || 'Error resetting password');
        }

    };

    return (
        <div className="popup-overlay">
            <div className="reset-popup-box">
                <button className="reset-close-btn" onClick={onClose}>&times;</button>
                <h3>Reset Password</h3>


                {success ? (
                    <>
                        <p className="reset-success-msg"> Your password has been reset and updated successfully!</p>
                        <button className="modal-btn confirm">Go to Login</button>
                    </>
                ) : (
                    <>
                        <div className="reset-input-group">
                            <FaLock className="reset-input-icon" />
                            <input
                                type={showNewPassword ? 'text' : 'password'}
                                placeholder="New Password"
                                className="reset-input"
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                            />
                            <span
                                className="reset-toggle"
                                onClick={() => setShowNewPassword(!showNewPassword)}
                            >
                                {showNewPassword ? <FaEyeSlash /> : <FaEye />}
                            </span>
                        </div>

                        <div className="reset-input-group">
                            <FaLock className="reset-input-icon" />
                            <input
                                type={showConfirmPassword ? 'text' : 'password'}
                                placeholder="Confirm Password"
                                className="reset-input"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                            />
                            <span
                                className="reset-toggle"
                                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                            >
                                {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                            </span>
                            {touched && confirmPassword && newPassword !== confirmPassword && (
                                <p className="reset-error-msg">Password does not match</p>
                            )}
                        </div>

                        {error && <p className="reset-error-msg">{error}</p>}

                        <div className="reset-button-row">
                            <button className="reset-btn" onClick={handleReset} disabled={isLoading}>
                                {isLoading ? <span className="button-spinner"></span> : 'Reset Password'}
                            </button>

                            <button className="reset-btn-cancel" onClick={onClose}>Cancel</button>
                        </div>
                    </>

                )}
            </div>
        </div>
    );
};

export default PasswordResetPopup;
